<template>
  <section class="py-20">
    <div class="container mx-auto">
      <div v-reveal class="mb-12 text-center">
        <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
          What we <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">do</span>
        </h2>
        <p class="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-400">
          From the first idea to production and beyond, across the web, mobile and the backend.
        </p>
      </div>

      <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <NuxtLink
          v-for="(service, index) in services"
          :key="service.slug"
          v-reveal="(index % 3) * 90"
          :to="`/services/${service.slug}`"
          class="group rounded-2xl border border-gray-200/60 bg-white/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent/40 hover:shadow-soft-lg dark:border-white/10 dark:bg-secondary-dark/50"
        >
          <div class="mb-4 flex size-12 items-center justify-center rounded-xl bg-gradient-to-r from-accent to-gradient-end">
            <component :is="service.icon" class="size-6 text-white" />
          </div>
          <h3 class="mb-2 text-lg font-bold text-ternary-dark group-hover:text-accent dark:text-ternary-light">
            {{ service.title }}
          </h3>
          <p class="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
            {{ service.description }}
          </p>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { services } from '~/data/services'
</script>
